<div *ngIf="vibrationRecord != undefined" class="">

    <div class="charts">

        <div class="pb-4 text-size-16">
            <span class="cursor" (click)="setTab('signal')"
                [ngClass]="{'highlighted-div': selectedTab === 'signal'}">{{'REPORT.SIGNAL' | translate}}</span>
            <span *ngIf="vibrationRecord?.recordMetadata?.recordType != 'Bargraph'" class=" ms-4 cursor" (click)="setTab('frequency')"
                [ngClass]="{'highlighted-div': selectedTab === 'frequency'}">{{'REPORT.FREQUENCY' | translate}}</span>
            <span class="ms-4 cursor" (click)="setTab('standard')"
                [ngClass]="{'highlighted-div': selectedTab === 'standard'}">{{'REPORT.STANDARD' | translate}}</span>
        </div>


        <div [ngStyle]="{'display': selectedTab === 'signal' ? 'block' : 'none'}">
            <div *ngFor="let a of vibrationRecord?.signalDataEntity?.signalData?.channels; index as i;" class="chart">
                <div class="row" >
                    <div class="col-3">
                        <div class="border p-1  mt-2 rounded-1">
                            <div class="text-size-14"> Channel {{i + 1}}</div>
                            <div *ngIf="i<3" class="text-muted text-size-12">
                                {{vibrationRecord.recordMetadata.transducerAxis[i] |
                                formatTransducerType }}
                            </div>
                            <div class="text-muted text-size-12">
                                {{vibrationRecord.recordMetadata.transducerType[i] |
                                formatTransducerType }}
                            </div>
                            <div *ngIf="i < 3" class="text-size-14">PPV :
                                {{findMaxAbsValue(vibrationRecord?.signalDataEntity?.signalData?.channels[i]?.timeSpectrum.ppvMin,
                                vibrationRecord?.signalDataEntity?.signalData?.channels[i].timeSpectrum.ppvMax) |
                                number : '1.2-2'}} {{i < 3 ? 'mm/s' : 'Pa'}}
                            </div>
                            <div *ngIf="i >= 3">
                                    Pa: 
                                      {{findMaxAbsValue(vibrationRecord?.signalDataEntity?.signalData?.channels[i]?.timeSpectrum.ppvMin,
                                        vibrationRecord?.signalDataEntity?.signalData?.channels[i].timeSpectrum.ppvMax) |
                                        number : '1.2-2'}} {{i < 3 ? 'mm/s' : 'Pa'}}
                            </div>
                             <div *ngIf="i >= 3">
                                    dB(L): 
                                    <ng-container *ngIf="!isNaN(findMaxAbsValue(vibrationRecord?.signalDataEntity?.signalData?.channels[i]?.timeSpectrum.ppvMin,
                                                            vibrationRecord?.signalDataEntity?.signalData?.channels[i].timeSpectrum.ppvMax))">
                                        {{
                                    pascalToDecibel(findMaxAbsValue(vibrationRecord?.signalDataEntity?.signalData?.channels[i]?.timeSpectrum.ppvMin,
                                                        vibrationRecord?.signalDataEntity?.signalData?.channels[i].timeSpectrum.ppvMax)) | number : '1.2-2' }}
                                      </ng-container>
                                      <ng-container *ngIf="isNaN(findMaxAbsValue(vibrationRecord?.signalDataEntity?.signalData?.channels[i]?.timeSpectrum.ppvMin,
                                                            vibrationRecord?.signalDataEntity?.signalData?.channels[i].timeSpectrum.ppvMax))">
                                        N/A
                                      </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="col-9">
                        <canvas class="canvas-custom-width" attr.id="canvas-{{i}}" height="110"></canvas>
                    </div>
                </div>
            </div>
        </div>

        <div [ngStyle]="{'display': selectedTab === 'frequency' ? 'block' : 'none'}">

            <div class="row">
                <div class="col-2">
                    <div *ngFor="let a of vibrationRecord?.signalDataEntity?.signalData?.channels; index as i;"
                        class="chart" >
                        <div class="border p-1 rounded-1 mt-2" *ngIf="i < 3">
                            <div class="text-size-14"> Channel {{i + 1}}</div>
                            <div class="text-muted text-size-12"> {{channelNames[i] | translate }}</div>
                            <div class="text-muted text-size-12"> Pic FFT: {{a.frequencySpectrum.maximumFrequencyHz | number :
                                '1.0-0'}} Hz</div>
                        </div>
                    </div>
                </div>
                <div class="col-10 mt-4">
                    <canvas id="canvas-fft" class="w-80 h-85"></canvas>

                </div>
            </div>

        </div>

        <div [ngStyle]="{'display': selectedTab === 'standard' ? 'block' : 'none'}">
            <div class="row-item-width-50 input-container mx-auto d-block pb-2">
                <label class="input-label">{{'REPORT.STANDARD' | translate }}</label>
                <ng-select
                    [items]="standards"
                    bindLabel="code"
                    bindValue="code"
                    [(ngModel)]="selectedStandardCode"
                    placeholder="Select standard"
                    (change)="onStandardChange($event)"
                    [clearable]="true"
                    [searchable]="true"
                    [closeOnSelect]="true">
                    <ng-template ng-option-tmp let-item="item">
                        {{ item.code }}{{ item.country ? ' — ' + item.country : '' }}
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                        {{ item.code }}{{ item.country ? ' — ' + item.country : '' }}
                    </ng-template>
                </ng-select>
            </div>

            <!-- Weighted PPV display (France-style standard) -->
            <div class="d-flex flex-wrap gap-3" *ngIf="standardGraphData?.weightedPpvValues">
                <div *ngFor="let a of vibrationRecord?.timeSpectrumWeighted; index as i;" class="chart">
                    <div *ngIf="i < 3" class="border p-1 mt-2 rounded-1 standard-card">
                        <div class="text-size-14"> Channel {{i + 1}}</div>
                        <div class="text-muted text-size-12"> {{vibrationRecord.recordMetadata.transducerAxis[i] |
                            formatTransducerType }}</div>
                        <div class="text-muted 12"> {{vibrationRecord.recordMetadata.transducerType[i] |
                            formatTransducerType }}</div>
                        <div class="text-size-14"> {{'VIBRATION.WEIGHTED' | translate }} :
                            {{abs(vibrationRecord?.timeSpectrumWeighted[i].ppvMax) |
                            number : '1.2-2'}} mm/s
                        </div>
                    </div>
                </div>
                <div class="chart">
                    <div class="border p-1 mt-2 rounded-1 legend-text standard-card">
                        <div class="text-size-14"> PPV Max</div>
                        <div class="text-size-14"> {{findPPVMax(vibrationRecord?.timeSpectrumWeighted) | number : '1.2-2'}} mm/s</div>
                    </div>
                </div>
            </div>

            <!-- Compliance chart (all other standards) -->
            <div *ngIf="standardGraphData && !standardGraphData.weightedPpvValues" style="position: relative; height: 400px;">
                <div class="text-center text-muted mb-2" *ngIf="standardGraphData.standardName">
                    <b>{{ standardGraphData.standardName }}</b>
                </div>
                <div class="text-center text-muted small mb-1">
                    {{ 'REPORT.MAX_FREQUENCY_SCALE' | translate }}: {{ getStandardMaxFrequencyLabel() }}
                </div>
                <canvas id="canvas-compliance" style="width:100%; height:100%;"></canvas>
            </div>
        </div>

    </div>
</div>